import Scripts from './scripts';
import MetaTags from './metaTags';
import LinkTags from './headerLinks';

export default (props: any) => (
  <main>
    <Scripts {...props} />
    <MetaTags {...props} />
    <LinkTags
      hideDefaultCanonical={props.hideDefaultCanonical}
      applyV2Styles={props.applyV2Styles}
      canonicalUrl={props.canonicalUrl}
    />
  </main>
);



// WEBPACK FOOTER //
// ./components/header/index.tsx